  // src/utils/constants.js

export const SOCIAL = {
  whatsapp: "https://wa.me/553498312358?text=Olá, Mario! Vim pelo seu site e gostaria de mais informações.", // Adicione o número real aqui
  
  instagram: "https://instagram.com/omariobento",

  avaliacaoFisica: "https://forms.gle/6GacbwkEaQLHWN9XA"
};

// Certifique-se de que as imagens estão na pasta public/ ou importadas corretamente
export const ASSETS = {
 /*  logo: './assets/logo.png',
  heroPhoto: '/assets/Mario_bento_foto_2.jpg',
  heroTitle: '/assets/nome_sem_fundo.png',
  acao: [
    '/assets/acao_1.jpg',
    '/assets/acao_2.jpg',
    '/assets/acao_4.jpg',
    '/assets/acao_5.jpg',
  ], */
  depoimentos: [
    // Substitua pelas imagens reais de depoimento quando tiver
    'https://placehold.co/600x400/222/FFF?text=Depoimento+1', 
    'https://placehold.co/600x400/222/FFF?text=Depoimento+2',
    'https://placehold.co/600x400/222/FFF?text=Depoimento+3',
  ]
};